var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "preferences",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 64,
    height: 64,
    transform: "translate(0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M48.205,28.667c0-.613-.027-1.2-.08-1.813l4.96-3.76a2.682,2.682,0,0,0,.693-3.467l-4.987-8.613a2.632,2.632,0,0,0-3.333-1.12L39.725,12.32a20.231,20.231,0,0,0-3.12-1.813l-.773-6.16A2.675,2.675,0,0,0,33.192,2H23.245a2.681,2.681,0,0,0-2.667,2.347l-.773,6.16a20.232,20.232,0,0,0-3.12,1.813L10.952,9.893a2.632,2.632,0,0,0-3.333,1.12l-4.987,8.64a2.688,2.688,0,0,0,.693,3.467l4.96,3.76c-.053.587-.08,1.173-.08,1.787s.027,1.2.08,1.813l-4.96,3.76a2.682,2.682,0,0,0-.693,3.467L7.619,46.32a2.632,2.632,0,0,0,3.333,1.12l5.733-2.427a20.232,20.232,0,0,0,3.12,1.813l.773,6.16a2.675,2.675,0,0,0,2.64,2.347h9.947a2.675,2.675,0,0,0,2.64-2.347l.773-6.16a20.231,20.231,0,0,0,3.12-1.813l5.733,2.427a2.632,2.632,0,0,0,3.333-1.12l4.987-8.613a2.688,2.688,0,0,0-.693-3.467L48.1,30.48A13.787,13.787,0,0,0,48.205,28.667ZM28.312,38a9.333,9.333,0,1,1,9.333-9.333A9.344,9.344,0,0,1,28.312,38Z",
    transform: "translate(3.795 3.333)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.91502df8ee3d13e5e9692e948c07856b.svg";
export { ForwardRef as ReactComponent };